export default __webpack_public_path__ + "static/media/internet.0d78a7e4.jpeg";